import styles from "./SectionTitle.module.scss";

export default function SectionTitle({ title, icon }) {
  return (
    <h2 className={`${styles.sectionTitle}`}>
      <span className={`${styles.icon}`}>{icon}</span>
      <span className={`${styles.title}`}>{title}</span>
    </h2>
  );
}
